import { Link } from "react-router-dom";

import { siteSections } from "../../../../content/siteSections";
import useCodeSimulation from "../../../../hooks/useCodeSimulation";

/**
 * Homepage hero with animated code backdrop.
 * Translation: Homepage hero with animated code backdrop.
 *
 * @param {Object} props - Hero props.
 * @returns {JSX.Element} Hero section.
 */
const Hero = ({ heroRef, prefersReducedMotion }) => {
  const renderedCodeSegments = useCodeSimulation(
    siteSections.codeSimulation,
    prefersReducedMotion
  );

  return (
    <section ref={heroRef} className="hero-section">
      <div className="hero-section__glow" />

      <div className="hero-code-wrapper" aria-hidden="true">
        <div className="hero-code">
          <div className="code-content">
            {renderedCodeSegments.map((segment, index) => (
              <span
                key={`${segment.token}-${index}`}
                className={segment.token === "plain" ? "" : `token-${segment.token}`}
              >
                {segment.text}
              </span>
            ))}
            <span className="code-cursor" />
          </div>
        </div>
        <div className="hero-code__glow" />
      </div>

      <div className="hero-section__inner">
        <h1>
          <span className="hero-section__accent">{siteSections.hero.titleAccent}</span>
          <br />
          <span>{siteSections.hero.titleMain}</span>
        </h1>

        <div className="glow-line hero-section__divider" />

        <div className="hero-section__content">
          <p className="section-intro">{siteSections.hero.description}</p>

          <div className="hero-section__actions">
            <Link
              to={siteSections.hero.primaryCta.href}
              className="button button-primary"
              title="Schedule a clinical data strategy session"
            >
              {siteSections.hero.primaryCta.label}
            </Link>
            <Link
              to={siteSections.hero.secondaryCta.href}
              className="button button-secondary"
              title="Browse our previous engineering engagements"
            >
              <span style={{ display: 'inline-block' }}>{siteSections.hero.secondaryCta.label} &rarr;</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
